import { cn } from '../lib/utils.js';

/**
 * Label/value pairs (`<dl>`). Empty values render as „–“ so gaps are visible, not hidden.
 * @param {{
 *   items: Array<{ label: import('react').ReactNode, value: import('react').ReactNode, hint?: import('react').ReactNode, key?: string }>,
 *   className?: string,
 *   labelWidth?: string,
 * }} props
 */
export function DescriptionList({ items, className, labelWidth = '10rem' }) {
  return (
    <dl
      data-slot="description-list"
      className={cn('grid grid-cols-1 gap-x-4 gap-y-2 text-sm sm:grid-cols-[var(--dl-label)_1fr]', className)}
      style={{ '--dl-label': labelWidth }}
    >
      {items.map((item, index) => {
        const empty = item.value === null || item.value === undefined || item.value === '';
        return (
          <div key={item.key ?? (typeof item.label === 'string' ? item.label : index)} className="contents">
            <dt className="text-muted-foreground">{item.label}</dt>
            <dd className="min-w-0 break-words">
              {empty ? <span className="text-muted-foreground">–</span> : item.value}
              {item.hint && <span className="ml-2 text-xs text-muted-foreground">{item.hint}</span>}
            </dd>
          </div>
        );
      })}
    </dl>
  );
}
